<template>
  <v-dialog
    v-model="visible"
    content-class="curation-dialog-open"
    persistent
    no-click-animation
    fullscreen
    dark
    scrollable
    @keydown="closeDialog"
    @input="closeDialog"
  >
    <v-card v-if="photo" tile class="d-flex flex-column h-100-percentage">
      <v-card-title>
        <div class="d-flex justify-space-between w-100-percentage">
          <div>
            <h2 class="text-h6 font-weight-bold">
              {{ photo.title }}
            </h2>
          </div>
          <div>
            <v-btn icon small @click="closeDialog">
              <v-icon small>
                fal fa-times
              </v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-card-text class="d-flex h-100-percentage">
        <v-container fluid class="pa-0 fill-height">
          <v-row class="fill-height">
            <v-col :md="fullPhoto ? 12 : 7" :lg="fullPhoto ? 12 : 8" cols="12">
              <Curation-photo :photo="photo" :full="full" />
            </v-col>
            <v-col
              v-show="!fullPhoto"
              cols="12"
              md="5"
              lg="4"
              class="aside-col"
            >
              <perfect-scrollbar :options="{ suppressScrollX: true }">
                <Aside-panel
                  :full="full"
                  :me="me"
                  :photo="photo"
                  :info="info"
                  :categories="categories"
                  :loading="loading"
                />
              </perfect-scrollbar>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import findIndex from 'lodash/findIndex'
import { mapState } from 'vuex'
import CurationPhoto from '@/components/account/curation/CurationPhoto.vue'
import AsidePanel from '@/components/account/curation/AsidePanel.vue'
import types from '@/utils/types'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'CurationDialog',
  components: {
    CurationPhoto,
    AsidePanel
  },
  props: {
    full: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      types,
      loading: false,
      fullPhoto: false
    }
  },
  computed: {
    ...mapState({
      me: state => state.auth.user,
      visible: state => state.account.curationDialogVisible,
      photo: state => state.account.curationDialogPhoto,
      info: state => state.photos.info,
      categories: state => state.account.categories,
      list: state => state.account.list
    })
  },
  watch: {
    visible: 'checkVisibility'
  },
  mounted() {
    EventBus.$on('toggle-photo-expand-dialog', v => this.toggleFullPhoto(v))
    EventBus.$on('set-curation-photo-from-sorround', id =>
      this.setCurationPhotoFromSorround(id)
    )
  },
  beforeDestroy() {
    const el = document.getElementsByTagName('html')[0]
    if (el) {
      el.classList.remove('dialog-fixed')
    }
  },
  methods: {
    toggleFullPhoto(v) {
      if (v) {
        this.fullPhoto = false
      } else {
        this.fullPhoto = !this.fullPhoto
      }
    },
    closeDialog(e) {
      if (!e || (e && (e.code === 'Escape' || e.type === 'click'))) {
        this.$store.dispatch('account/setCurationDialog', {
          visible: false
        })
        EventBus.$emit('toggle-photo-expand-dialog', true)
      }
    },
    checkVisibility(value) {
      const el = document.getElementsByTagName('html')[0]
      if (value) {
        el.classList.add('dialog-fixed')
      } else {
        el.classList.remove('dialog-fixed')
      }
    },
    setCurationPhotoFromSorround(id) {
      const nextIndex = findIndex(this.list, p => p.id === id)
      if (nextIndex > -1) {
        const photo = this.list[nextIndex]
        this.setPhotoData(photo)
      }
    },
    async setPhotoData(photo) {
      try {
        this.loading = true
        this.$store.dispatch('account/setCurationDialog', {
          visible: true,
          photo
        })
        await this.$store.dispatch('photos/getInfo', photo.id)
        await this.$store.dispatch('comments/resetStore')
        if (this.full) {
          const nextIndex = findIndex(this.list, p => p.id === photo.id)
          if (nextIndex > -1) {
            if (nextIndex + 1 === this.list.length - 2) {
              EventBus.$emit('load-more-from-sorround')
            }
          }
          this.$store.dispatch('account/setSorround', photo.id)
        }
      } catch (error) {
        this.$asa.appInsights('Comp: account/curation/CurationDialog.vue - method: setPhotoData', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.aside-col {
  max-height: 90vh;
  overflow: hidden;
}
.ps {
  height: 90vh;
}
.curation-dialog-open {
  overflow: hidden;
}
</style>

<style>
.dialog-fixed {
  overflow: hidden;
}
</style>
